<template>
    <div class="w-full max-w-30rem mb-6">
        <span class="H6-Medium block text-center">Your plan change is scheduled</span>
        <span class="Label block text-center mt-1 mb-6">We've received your request to change to the {{ targetPackageName }} plan.</span> 

        <div class="w-full text-center mb-6">
            <p class="Label m-0 mb-2">You'll keep your current features until</p>
            <h3 class="text-lg Label font-semibold m-0 mb-2">{{ nextBillingDate }}</h3>
            <p class="Label m-0 mb-5 px-3">After this date, your plan will automatically downgrade to {{ targetPackageName }} and you'll be charged accordingly.</p>
        </div>

        <hr class="border-top-1 border-none border-gray-200 mb-4" style="width: 120%; margin-left: -10%;" />

        <div class="w-full text-left">
            <span class="Label font-semibold block mb-3">What happens next</span>
            <ol class="Label m-0 pl-3 flex flex-column gap-2">
                <li>Continue enjoying all Standard features until {{ nextBillingDate }}</li>
                <li>Your plan will automatically change to {{ targetPackageName }}</li>
                <li>You can cancel this change anytime before {{ nextBillingDate }}</li>
            </ol>
        </div>

        <div class="w-full p-6">
            <Button label="Continue learning" class="w-full custom-brown-btn" @click="$emit('continue')" />
        </div>

        <p class="Label text-xs text-center">A confirmation email has been sent with these details</p>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import Button from 'primevue/button';

defineProps({
    nextBillingDate: String,
    targetPackageName: {
        type: String,
        default: 'Campus Horizon'
    }
});

defineEmits(['continue']);
</script>

<style scoped>
.custom-brown-btn {
    background-color: var(--yellow-500) !important;
    border: 1px solid var(--yellow-500) !important;
    color: white !important;
    font-weight: 600;
}
.custom-brown-btn:hover {
    background-color: var(--yellow-600) !important;
    border-color: var(--yellow-600) !important;
}
</style>